import { render, staticRenderFns } from "./pDetail.vue?vue&type=template&id=37d9716c&scoped=true"
import script from "./pDetail.vue?vue&type=script&lang=js"
export * from "./pDetail.vue?vue&type=script&lang=js"
import style0 from "./pDetail.vue?vue&type=style&index=0&id=37d9716c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d9716c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d9716c')) {
      api.createRecord('37d9716c', component.options)
    } else {
      api.reload('37d9716c', component.options)
    }
    module.hot.accept("./pDetail.vue?vue&type=template&id=37d9716c&scoped=true", function () {
      api.rerender('37d9716c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statisticalAnalysis/facesheetRecycling/detailSearch/pDetail.vue"
export default component.exports